import { render, staticRenderFns } from "./PartnerSelector.vue?vue&type=template&id=1bcfe40d&scoped=true"
import script from "./PartnerSelector.vue?vue&type=script&lang=ts"
export * from "./PartnerSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcfe40d",
  null
  
)

export default component.exports